import axios from 'axios';

// 创建axios实例
const requests = axios.create({
  baseURL: 'https://yulijishu.yuli811.com/api', // 基础URL，可根据实际接口地址修改
  timeout: 10000, // 超时时间，单位为毫秒
});

// 请求拦截器
requests.interceptors.request.use(
  config => {
    // 在发送请求之前可以做一些处理，例如添加token到请求头
    /* const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } */
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
requests.interceptors.response.use(
  response => {
    // 对响应数据进行处理，例如检查状态码，统一处理错误
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return Promise.reject(data);
    }
  },
  error => {
    // 处理响应错误，例如提示用户网络错误等
    console.error('接口请求错误：', error);
    return Promise.reject(error);
  }
);

export default requests;